// import { disablePageScroll, enablePageScroll } from 'scroll-lock';
// import { getElementFromEvent } from '../utils';

export default class DownloadForm {
	static init(e) {
		const els = e.detail.element.querySelectorAll('[data-download-form]');
		els.forEach((el) => new this(el));
	}

	constructor(el) {
		this.el = el;

		// Form
		this.isSubmitting = false;
		this.form = this.el;
		this.form.querySelectorAll('[data-rr]').forEach((field) => this.handleHoneyPotField(field));
		this.form.addEventListener('submit', this.submit.bind(this));
	}

	handleHoneyPotField(field) {
		field.removeAttribute('required');
		field.tabIndex = -1;
		field.parentNode.classList.add('rr');
	}

	submit(e) {
		e.preventDefault();

		if (this.isSubmitting) {
			return; // Prevent multiple submit requests
		}

		this.isSubmitting = true;

		fetch(this.form.action, {
			method: 'POST',
			body: new FormData(this.form),
		})
			.then((response) => response.json())
			.then((data) => this.displaySuccess(data))
			.catch((error) => this.displayFailure(error))
			.finally(() => (this.isSubmitting = false));
	}

	displaySuccess(data) {
		if (!data.success) {
			this.displayFailure(data.data);
			return;
		}

		if (!data.data.file) {
			return;
		}

		this.downloadFile(data.data.file);
	}

	displayFailure(data) {
		console.log(data);
	}

	downloadFile(url) {
		const a = document.createElement('a');

		a.href = url;
		a.setAttribute('data-barba-prevent', 'self');
		a.setAttribute('target', '_blank');
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}
